module.exports = __webpack_public_path__ + "static/Rahel-6403a28bc8394f319fe7cd79f528e858.jpg";